import { BatchHeatmapCell } from '../domain/types';

const ZERO = BigInt(0);

const toBigIntOrZero = (value: string): bigint => {
  try {
    return BigInt(value);
  } catch {
    return ZERO;
  }
};

/**
 * Batches ordered by their position in the file.
 *
 * The heatmap reads left to right as a picture of the file itself, so cells
 * must follow `byteOffsetStart` — which is a BIGINT string, so comparing it
 * with `Number` would collapse offsets past `Number.MAX_SAFE_INTEGER` into
 * the same value. Returns a new array; PDGS's response is not mutated.
 */
export const sortBatchesByByteOffset = (
  batches: BatchHeatmapCell[],
): BatchHeatmapCell[] =>
  [...batches].sort((first, second) => {
    const firstOffset = toBigIntOrZero(first.byteOffsetStart);
    const secondOffset = toBigIntOrZero(second.byteOffsetStart);

    if (firstOffset === secondOffset) {
      return 0;
    }

    return firstOffset < secondOffset ? -1 : 1;
  });
